<template>
  <div style="width:100%"
       class="adviser_box">
    <!-- 左侧图片 -->
    <el-image class="maxImg"
              :src="$imgUrl + 'zxgu/tp_'+ (activeIndex+1) +'.jpg'"
              alt=""></el-image>
    <div class="adviser_content">
      <div class="adviser_tab">
        <div class="adviser_tab_item"
             :style="{'backgroundColor':activeIndex == index?'#DE1F26':'','color':activeIndex == index?'#fff':'#333333','borderRadius':activeIndex == index && index==0?'10px 0  0 10px':activeIndex == index && index==4?'0 10px 10px 0':''}"
             v-for="(item,index) in 5"
             :key="index"
             @click="itemClick(index)">
          <div>{{list[index].text1}}</div>
          <!-- <div>{{list[index].text2}}</div> -->
          <div class="num">0{{item}}</div>
          <div class="bottom"
               v-if="activeIndex == index"> <i style="color:#DE1F26"
               class="el-icon-caret-bottom"></i> </div>
        </div>
      </div>
      <div class="text"><span>{{list[activeIndex].text1}}：</span> {{list[activeIndex].text2}}</div>
      <!-- <div class="text"><span>诊断阶段：</span> 对企业各门店进行实地考察并进行现场指导存在问题及调 整思路，梳理关键流程的纲目和主体框架。</div> -->
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      activeIndex: 0,
      list: [{ text1: '老师入驻', text2: '多位老师通过深入企业调研并结合项目方案每月分阶段执行，当月做下月检核，纠偏持续跟进落地结果' }, { text1: '会议沟通', text2: '通过对部门工作进行梳理，解决当下难题并给出行之有效的方法并制定落地计划' }, { text1: '现场实操', text2: '项目实施中对各岗位进行培训，统一思想和执行步骤，带着部门实操落地' }, { text1: '结果产出', text2: '在项目实施过程中，让各部门形成可落地执行的工作流程与岗位职责表格表单' }, { text1: '远程指导', text2: '项目进展中与结束后，通过老师与企业方持续沟通，推进项目稳定执行保障落地' }],
      imgList: [
        { url: 'https://img0.baidu.com/it/u=2266992387,3653937162&fm=253&fmt=auto&app=138&f=JPEG?w=346&h=500', text: '线上教育' },
        { url: 'https://img2.baidu.com/it/u=1318432244,4009299303&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=711', text: '线下培训' },
        { url: 'https://img2.baidu.com/it/u=2616025538,1484344267&fm=253&fmt=auto&app=138&f=JPEG?w=333&h=500', text: '咨询顾问' },
        { url: 'https://img2.baidu.com/it/u=154933639,2780893441&fm=253&fmt=auto&app=138&f=JPEG?w=392&h=500', text: '零售圈子' },
        { url: 'https://img0.baidu.com/it/u=1913256758,563789401&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=889', text: '数字工具' }
      ]
    }
  },
  methods: {
    itemClick (index) {
      this.activeIndex = index;
    }
  }
}
</script>
<style lang="less" scoped>
.adviser_box {
  display: flex;
  width: 100%;
  position: relative;
  .maxImg {
    width: 660px;
    height: 405px;
  }
  .adviser_content {
    position: absolute;
    right: 0;
    bottom: 34px;
    // height: 260px;
    background-color: #fff;
    max-width: 603px;
    padding: 65px 38px 38px 83px;
    box-sizing: border-box;
    .adviser_tab {
      position: absolute;
      top: -40px;
      height: 80px;
      right: 20px;
      width: 500px;
      background: #ffe4e5;
      display: flex;
      border-radius: 10px;
      justify-content: center;
      align-items: center;
      // align-items: center;
      .adviser_tab_item {
        flex: 1;
        height: 100%;
        padding: 15px 20px 0 20px;
        text-align: center;
        position: relative;
        font-size: 22px;
        font-weight: bold;
        box-sizing: border-box;
        cursor: pointer;
        .bottom {
          bottom: -22px;
          left: 0;
          width: 100%;
          position: absolute;
          font-size: 30px;
        }
        .num {
          position: absolute;
          top: -16px;
          text-shadow: 0px 2px 3px #333333;
          font-size: 24px;
          font-style: italic;
          color: #ffffff;
          left: 0;
          width: 100%;
          text-align: center;
        }
      }
    }
    .text {
      font-size: 16px;
      color: #333;
      span {
        color: #de1f26;
      }
    }
  }
}
</style>